import {
  http
} from '@/plugins/http';
import {
  getData
} from '@/util/get';

const PREFIX_API = 'estudante';

const fetchEstudantes = (params) => {
  return http.post(`${PREFIX_API}/busca`, params).then(getData);
};

const fetchEstudante = (id_matricula) => {
  return http.get(`${PREFIX_API}/${id_matricula}`).then(getData);
};

const fetchUnidades = () => {
  return http.get(`${PREFIX_API}/filtro-busca/unidades`).then(getData);
};

const fetchModalidades = (params) => {
  return http.post(`${PREFIX_API}/filtro-busca/modalidades`, params).then(getData);
};

const fetchModelosNegocio = (params) => {
  return http.post(`${PREFIX_API}/filtro-busca/modelos-negocio`, params).then(getData);
};

const fetchCursos = (params) => {
  return http.post(`${PREFIX_API}/filtro-busca/cursos`, params).then(getData);
};

const fetchTurmas = (params) => {
  return http.post(`${PREFIX_API}/filtro-busca/turmas`, params).then(getData);
};

const fetchMaxChUnidade = (unidade) => {
  return http.get(`${PREFIX_API}/filtro-busca/max-ch-unidade`, {
    params: { unidade: unidade }
  }).then(getData);
};

const fetchVariaveisSimulacao = () => {
  return http.get(`${PREFIX_API}/variaveis-simulacao`).then(getData);
};

const fetchVariaveisAbaInformacoes = () => {
  return http.get(`${PREFIX_API}/variaveis-informacoes`).then(getData);
};

const fetchVariaveisImportancia = (id_matricula) => {
  return http.get(`${PREFIX_API}/${id_matricula}/variaveis-importancia`).then(getData);
};

const fetchSimulacao = (id_matricula, params) => {
  return http.post(`${PREFIX_API}/${id_matricula}/simular-predicao`, params).then(getData);
};

const fetchPlotVariavel = (id_matricula, params) => {
  return http.get(`${PREFIX_API}/${id_matricula}/plot-variavel`, {params}).then(getData);
};

export default {
  fetchEstudantes,
  fetchEstudante,
  fetchUnidades,
  fetchModalidades,
  fetchModelosNegocio,
  fetchCursos,
  fetchTurmas,
  fetchMaxChUnidade,
  fetchVariaveisSimulacao,
  fetchSimulacao,
  fetchVariaveisImportancia,
  fetchVariaveisAbaInformacoes,
  fetchPlotVariavel,
};



// WEBPACK FOOTER //
// ./src/pages/estudantes/api/index.js